<app-layout>
  <app-layout-content>
    <div class="main">
      <div class="head">
        <app-go-back-button (click)="goBack()"
          style="justify-self: start">
          {{ 'HISTORY.RECONCILIATION.notice_info' | translate }}
        </app-go-back-button>

        <div class="dates">
          <app-date [date]="notice.createdAt" [matTooltip]="'COLUMNS.create' | translate" style="text-align: right"></app-date>

          <mat-divider [vertical]="true"></mat-divider>

          <app-date [date]="notice.updatedAt" [matTooltip]="'COLUMNS.update' | translate"></app-date>
        </div>

        <div class="status">
          @switch (notice.status) {
            @case ('PENDING') {
              <mat-icon class="rotation">autorenew</mat-icon>
              <span>{{ 'CLAIM_STATES.in_process' | translate }}</span>
            }
            @case ('SENT') {
              <mat-icon color="primary">check_circle_outlined</mat-icon>
              <span>{{ 'SENDING_STATUS.sent' | translate }}</span>
            }
            @case ('ERROR') {
              <mat-icon color="warn">highlight_off</mat-icon>
              <span>{{ 'SENDING_STATUS.error' | translate }}</span>
            }
          }
        </div>
      </div>

      @if (notice.subject) {
        <div>
          <span class="subtitle">{{ 'HISTORY.RECONCILIATION.subject' | translate }} </span> {{ notice.subject }}
        </div>
      }

      <div class="recipient">
        <span class="subtitle">{{ 'HISTORY.RECONCILIATION.recipient' | translate }} </span>

        <img [src]="'assets/svg/' + (notice.recipient.type | lowercase) + '.svg'"
          [alt]="notice.recipient.type | lowercase">

        <span>{{ notice.recipient.contact }}</span>
      </div>

      <mat-divider></mat-divider>

      <div>
        <span class="subtitle">{{ 'HISTORY.RECONCILIATION.notice_text' | translate }}</span>
        <pre>{{ notice.text }}</pre>
      </div>
    </div>
  </app-layout-content>
</app-layout>
